<script>
    let shown = true;
    export function show() {
        shown = true;
    }
    export function hide(){
        shown = false;
    }
</script>

<style>

    .modal-wrapper {
        background-color: rgb(0,0,0);
        background-color: rgba(0,0,0,.6);
        overflow: hidden;
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 1;
    }
    .modal {
        background-color: white;
        max-width: 50vw;
        max-height: 80%;
        padding: 1rem;
        margin: 5% auto;
        overflow: scroll;
    }
    .close {
        float: right;
        cursor: pointer;
    }
    .close:hover {
        font-weight: bold;
    }

</style>

<svelte:window
    on:keydown={e => {
        if (e.keyCode == 27){
            hide();
        }
    }} />

{#if shown}
    <div class="modal-wrapper">
        <div class="modal">

            <slot />
        </div>
    </div>
    {/if}
